import { render, staticRenderFns } from "./ValidatedTextArea.vue?vue&type=template&id=71d3a586&scoped=true"
import script from "./ValidatedTextArea.vue?vue&type=script&lang=js"
export * from "./ValidatedTextArea.vue?vue&type=script&lang=js"
import style0 from "./ValidatedTextArea.vue?vue&type=style&index=0&id=71d3a586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d3a586",
  null
  
)

export default component.exports